require('../../modules/es7.string.trim-left');
module.exports = require('../../modules/_core').String.trimLeft;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/trim-start.js
// module id = 231
// module chunks = 0